function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import HubspotContactForm from "segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form";
import HubspotContactFormProps from "segments/desktop/core-components/hubspot-contact-form/default-props";
import { StyledHubspotSideBySideFormComponent } from "./hubspot-side-by-side-form-component.scss";
class HubspotSideBySideFormComponent extends PureComponent {
    render() {
        const _this_props = this.props, { formId, source, overrideCampaignId, lastNameFirst, urlToRedirectAfterSubmission } = _this_props, restProps = _object_without_properties(_this_props, [
            "formId",
            "source",
            "overrideCampaignId",
            "lastNameFirst",
            "urlToRedirectAfterSubmission"
        ]);
        const replaceTextComponentProps = {
            formId,
            source,
            overrideCampaignId,
            lastNameFirst,
            urlToRedirectAfterSubmission
        };
        return /*#__PURE__*/ _jsx(StyledHubspotSideBySideFormComponent, {
            className: "hubspot-side-by-side-form-component",
            children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread_props(_object_spread({
                replaceTextComponent: HubspotContactForm
            }, restProps), {
                replaceTextComponentProps: replaceTextComponentProps
            }))
        });
    }
}
export { HubspotSideBySideFormComponent as default };
HubspotSideBySideFormComponent.defaultProps = _object_spread({
    width: "100%",
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "/static/img/segment-layout-default-images/sales_social.png"
        }
    }
}, HubspotContactFormProps);
